import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { ChangeDetectionStrategy, Component, Input, OnInit, Optional } from '@angular/core';
import { ControlContainer, FormArray, FormBuilder, FormGroup, FormGroupDirective } from '@angular/forms';
import { AuthService } from '@klickdata/core/auth';
import { Customer, CustomerService } from '@klickdata/core/customer';
import { MessageService } from '@klickdata/core/message';
import { MessageErrorComponent } from '@klickdata/core/message/src/message-error/message-error.component';
import { QuickAccess } from '@klickdata/core/quick-access';
import { User, UserService } from '@klickdata/core/user';
import { Utils } from '@klickdata/core/util';
import { OnDestroyHandler } from 'apps/klickdata/src/app/shared/onDestroy-handler/onDestroy-handler';
import { BehaviorSubject, debounceTime, distinctUntilChanged, filter, Observable, switchMap, takeUntil } from 'rxjs';

@Component({
    selector: 'app-quick-access-platform-listing',
    templateUrl: './quick-access-platform-listing.component.html',
    styleUrls: ['./quick-access-platform-listing.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
})
export class QuickAccessPlatformListingComponent extends OnDestroyHandler implements OnInit {
    @Input() user: User;
    @Input() customer: Customer;
    @Input() icon: string;
    @Input() title: string;
    @Input() context: string;
    @Input() quickAccessData: QuickAccess[];
    @Input() formArrayName: string;
    @Input() onDisableFavorite: BehaviorSubject<boolean>;
    @Input() onDisableShortlisted: BehaviorSubject<boolean>;
    public quickAccessFormArray: FormArray;
    constructor(
        @Optional() protected parentFormDirective: FormGroupDirective,
        protected fb: FormBuilder,
        protected userService: UserService,
        protected customerService: CustomerService,
        protected auth: AuthService,
        protected message: MessageService
    ) {
        super();
    }

    ngOnInit(): void {
        this.quickAccessFormArray = this.parentFormDirective.form.get(this.formArrayName) as FormArray;
        // this.quickAccessFormArray.valueChanges
        //     .pipe(
        //         filter((value) => false), // TODO: Remove this filter
        //         takeUntil(this.destroy),
        //         debounceTime(500),
        //         distinctUntilChanged((f1, f2) => Utils.arraysEqual(f1, f2)),
        //         switchMap((value) =>
        //             this.user
        //                 ? this.userService.update({
        //                       id: this.user.id,
        //                       metadata: {
        //                           [this.formArrayName]: value,
        //                       },
        //                   })
        //                 : this.customerService.update({
        //                       id: this.customer.id,
        //                       metadata: {
        //                           [this.formArrayName]: value,
        //                       },
        //                   })
        //         )
        //     )
        //     .subscribe(() => this.auth.refreshToken());
    }
    private updateQuickAccess(quickAccess: QuickAccess[]) {
        const removedDefaultQuickAccess = quickAccess.map(({ default: _default, ...rest }) => rest);
        const updated: Observable<User | Customer> = this.user
            ? this.userService.update({
                  id: this.user.id,
                  metadata: {
                      [this.formArrayName]: removedDefaultQuickAccess,
                  },
              })
            : this.customerService.update({
                  id: this.customer.id,
                  metadata: {
                      [this.formArrayName]: removedDefaultQuickAccess,
                  },
              });
        updated.pipe(takeUntil(this.destroy)).subscribe(() => this.auth.refreshToken());
    }
    onDelete(i: number) {
        this.updateQuickAccess([{ route: this.quickAccessFormArray.at(i).value.route, deleted: true }]);
        this.quickAccessFormArray.removeAt(i);
        this.quickAccessFormArray.markAsDirty();
    }
    drop(event: CdkDragDrop<QuickAccess[]>) {
        moveItemInArray(this.quickAccessFormArray.controls, event.previousIndex, event.currentIndex);
        this.updateItemsOrder();
        this.quickAccessFormArray.markAsDirty();
        this.quickAccessFormArray.updateValueAndValidity();
    }
    updateItemsOrder() {
        this.quickAccessFormArray.controls.forEach((control, index) => {
            control.get('order').patchValue(index + 1);
        });
        this.updateQuickAccess(
            this.quickAccessFormArray.controls.map((control) => ({
                route: control.value.route,
                order: control.value.order,
            })) as QuickAccess[]
        );
    }
    onClickFavorite(i: number, favorite: boolean) {
        if (!this.onDisableFavorite.value) {
            this.quickAccessFormArray.at(i).get('favorite').patchValue(!favorite);
        } else {
            // this.message.openMessage(MessageErrorComponent, $localize`You can have only 3 favorites`);
            this.quickAccessFormArray.at(i).get('favorite').patchValue(false);
            if (favorite) {
                this.quickAccessFormArray.at(i).get('favorite').patchValue(false);
            }
        }
        this.updateQuickAccess([this.quickAccessFormArray.at(i).value]);
    }
    onClickShortlisted(i: number, navbar: boolean) {
        if (!this.onDisableShortlisted.value) {
            this.quickAccessFormArray.at(i).get('navbar').patchValue(!navbar);
        } else {
            // this.message.openMessage(MessageErrorComponent, $localize`You can have only 3 navbar items`);
            this.quickAccessFormArray.at(i).get('navbar').patchValue(false);
            if (navbar) {
                this.quickAccessFormArray.at(i).get('navbar').patchValue(false);
            }
        }

        this.updateQuickAccess([this.quickAccessFormArray.at(i).value]);
    }
    onEnabledChange(i: number) {
        this.updateQuickAccess([this.quickAccessFormArray.at(i).value]);
    }
}
